export var DebugSessionDataType;
(function (DebugSessionDataType) {
    DebugSessionDataType["OTLP_TRACES"] = "OTLP_TRACES";
    DebugSessionDataType["OTLP_LOGS"] = "OTLP_LOGS";
    DebugSessionDataType["RRWEB_EVENTS"] = "RRWEB_EVENTS";
})(DebugSessionDataType || (DebugSessionDataType = {}));
//# sourceMappingURL=session.js.map